// extracted by mini-css-extract-plugin
export default {"Text":"single-select-editor-module__Text--hyUn7"};